/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";

import routes from "routes";
import ProductLogo from "components/ProductLogo";
import Loader from "components/Loader";

const ThingAuth = (props) => {
  useEffect(() => {
    return () => {
      document.body.classList.remove("bg-info");
    };
  }, []);

  const getRoutes = (routes) =>
    routes.map((prop, key) => {
      if (prop.layout === "/tr") {
        const Comp = prop.component;
        return (
          <Route path={prop.path} element={<Comp {...props} />} key={key} />
        );
      } else {
        return null;
      }
    });

  const onChangeUserClick = () => {
    props.onSignOut();
  };

  const username = props.auth.user.idToken.name;

  return (
    <div className="main-content bg-info">
      {/* <AuthNavbar /> */}
      <div className="header bg-gradient-white py-5 py-lg-4">
        <Container>
          <div className="header-body text-center mb-8">
            <Row className="justify-content-center">
              <Col lg="5" md="6">
                <ProductLogo logoWidth="w-50" />
                <br />
                <h4 className="text-default">
                  {props.t("registerThing.welcome") + " " + username}!
                </h4>
                <h5
                  className="btn text-center border border-info p-2 change-user-button"
                  onClick={onChangeUserClick}
                >
                  {props.t("registerThing.changeUser")}
                </h5>
              </Col>
            </Row>
          </div>
        </Container>
        <div className="separator separator-bottom separator-skew zindex-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon className="fill-info" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </div>
      {/* Page content */}
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Suspense fallback={<Loader />}>
            <Routes>{getRoutes(routes)}</Routes>
          </Suspense>
        </Row>
      </Container>
    </div>
  );
};

export default withTranslation("common")(ThingAuth);

ThingAuth.propTypes = {
  auth: PropTypes.object.isRequired,
  onSignOut: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
